import React, { useState } from "react";

import { getCsvResponse } from "api/loginRoutes";
import { downloadDataAsFile } from "utils";
import { ButtonPrimary } from "components/base/BaseButton";


export default ({
    // onSuccess,
}) => {

    const [loading, setLoading] = useState(false);

    const downloadAuthNumbers = () => {
        setLoading(true);
        getCsvResponse("auth_number:get_list")
            .then((response) => {
                downloadDataAsFile(response, "Auth Numbers.csv")
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <ButtonPrimary
            loading={loading}
            onClick={downloadAuthNumbers}
        >
            Download
        </ButtonPrimary>
    )
};